document.addEventListener("DOMContentLoaded", function () {
    if (window.location.href.indexOf("/careers/?") != -1) {

        let results = document.getElementById('loop-results');

        //if we have some results
        if(results) {
            
            //scroll to the first one
            results.parentNode.scrollIntoView({behavior: "smooth", block: "start"});
        }
    }
});